import module from '../module';
import Constants from '../../../utils/CommonConstants';
import { retailerService } from "../../../utils/helpers/retailerService";
import moment from 'moment';

export class CheckoutService {
  static $inject = ['$http', 'cartonomyConfig', 'ConfigurationService', '$rootScope', 'Session'];

  constructor(httpService, cartonomyConfig, configurationService, rootScope, sessionService) {
    this._urlBase = cartonomyConfig.ApiV2 + 'checkout';
    this._httpService = httpService;
    this._configurationService = configurationService;
    this._rootScope = rootScope;
    this._sessionService = sessionService;
    this.cartonomyConfig = cartonomyConfig;
  }

  async _getDefaultRetailerId() {
    const retailer = await this._configurationService.getItem('retailer');
    return retailer.id;
  }

  async getVendorList() {

    if (this._vendorList) {
      return this._vendorList;
    }

    const retailerId = await this._getDefaultRetailerId();
    const response = await this._httpService.get(this._urlBase + '/options/' + retailerId);
    this._vendorList = response.data;
    return this._vendorList;
  }

  async getVendorMap() {
    const vendorList = await this.getVendorList();
    const ret = {};
    vendorList.forEach(vendor => {
      ret[vendor.vendorName] = vendor.vendorId;
    });
    return ret;
  }

  async beginCheckout(vendorName) {
    const vendorMap = await this.getVendorMap();
    const response = await this._httpService.post(this._urlBase + '/begin', {
      vendorId: vendorMap[vendorName]
    });
    return response.data;
  }

  async submitOrder(vendorName, configuration) {
    const vendorMap = await this.getVendorMap();
    const url = this._urlBase + '/submit';
    let params = {
      vendorId: vendorMap[vendorName],
      billing: {},
      amount: configuration.orderTotal,
      isAuthorization: configuration.isAuthorization
    };
    if (vendorName === 'Square') {
      params.nonce = configuration.nonce;
      params.billing.zip = configuration.cardData.billing_postal_code;
    } else {
      params.externalPayerId = configuration.externalPayerId;
    }
    const response = await this._httpService.post(url, params);
    this._rootScope.$emit(Constants.RootEvents.PAYMENT_STATUS_CHANGED);
    return response.data;
  }

  async paymentAuthorizedOrCaptured() {
    if (!(await this._sessionService.loggedIn())) {
      return false;
    }

    if (this._paymentStatusPromise) {
      return this._paymentStatusPromise;
    }

    this._paymentStatusPromise = this._httpService.get(this._urlBase + '/paymentStatus')
      .then(response => {
        setTimeout(() => {
          this._paymentStatusPromise = null
        }, 500);
        return response.data == 1 || response.data === 2
      });

    return this._paymentStatusPromise;
  }

  async getShopifyCheckoutInfo(userId) {
    let shopifyCheckoutUrl = this.cartonomyConfig.ApiV2 + 'shopify/checkout';

    if (userId) {
      shopifyCheckoutUrl += `?asUserId=${ userId }`
    }

    let response = await this._httpService.get(shopifyCheckoutUrl);
    let data = response.data;

    let errors = data.items.some(item => item.errors.length > 0);

    let retailer = await this._configurationService.getItem('retailer');

    let url = '//' + retailer.externalAPIURL + '/cart/';

    let cartItemUrlPortions = [];
    let cartInfoObj = {
      cartItems: [],
      customAttributes: {
        'cartonomy-bearer': await this._sessionService.getAuthToken(),
        'cartonomy-retailer': (await retailerService.checkRetailer()).retailer.id,
      },
      discount: null
    };

    if (userId) {
      cartInfoObj.customAttributes['cartonomy-participant-user-id'] = userId;
    }

    if (data.ownerOrderNumber) {
      cartInfoObj.customAttributes['GroupOrderNumber'] = data.ownerOrderNumber;
    }

    if (data.deliveryDate) {
      cartInfoObj.customAttributes['DeliveryDate'] = moment.utc(data.deliveryDate).local().format('LLL');
    }

    for (let i = 0; i < data.items.length; i ++) {
      cartInfoObj.cartItems.push({
        id: data.items[i].variantID,
        quantity: data.items[i].quantity,
        itemOptions: data.items[i].itemOptions
      });
      cartItemUrlPortions.push(data.items[i].variantID + ':' + data.items[i].quantity);
    }

    url += cartItemUrlPortions.join(',') + "?attributes[cartonomy-bearer]=" + await this._sessionService.getAuthToken();

    if (data.discountCode !== undefined && data.discountCode != null && data.discountCode != "") {
      cartInfoObj.discount = data.discountCode;
      url += "&discount=" + encodeURIComponent(cartInfoObj.discount);
    }

    const shopifyCheckoutInfo = {
      url: url,
      cartInfo: cartInfoObj,
      warningInfo: null,
      ownerPaid: data.ownerPaid
    };

    //check if hulkapps extension installed, it changes price
    if (errors && !window.hulkapps) {
      let errorsList = [];
      data.items.forEach(item => {
        errorsList = errorsList.concat(item.errors);
      });

      shopifyCheckoutInfo.warningInfo = "Prices in your cart have changed.<p></p><p></p>" + errorsList.join('.<br />. Do you want to continue checking out, or to review your cart again?')
    }

    return shopifyCheckoutInfo;
  }

  async getAmazonCheckoutInfo() {
    const amazonCheckoutUrl = this.cartonomyConfig.ApiV2 + 'amazon/checkout';
    let response = await this._httpService.get(amazonCheckoutUrl);

    const amazonCheckoutInfo = {
      url: response.data,
      cartInfo: null,
      warningInfo: null
    };

    return amazonCheckoutInfo;
  }

  async getWalmartCheckoutInfo() {
    const walmartCheckoutUrl = this.cartonomyConfig.ApiV2 + 'walmart/checkout';
    let response = await this._httpService.get(walmartCheckoutUrl);

    const walmartCheckoutInfo = {
      url: null,
      cartInfo: response.data,
      warningInfo: null
    };

    return walmartCheckoutInfo;
  }

  async getFreshopCheckoutInfo() {
    const freshopCheckoutUrl = this.cartonomyConfig.ApiV2 + 'freshop/checkout';
    let response = await this._httpService.get(freshopCheckoutUrl);

    const freshopCheckoutInfo = {
      url: null,
      cartInfo: response.data,
      warningInfo: null
    };

    return freshopCheckoutInfo;
  }
}

module.service('CheckoutService', CheckoutService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/CheckoutService.js